/**
 * @file 如果页面被嵌入在客户端中，需要从当前页面公共参数中的提取特定参数，后续哈勃日志上报中对应的字段都上报为客户端的参数, 可能的影响面 高途、途途、精品、公考等内嵌的h5页面
 * https://wiki.baijia.com/pages/viewpage.action?pageId=160671215
 * @author leibin@baijia.com
 */

import {isInGaoTuApp} from './env';
import {parse as parseQuery} from './json';
import cookie from './cookie';

/**
 * 判断对象不为空
 * @param {Object} obj js对象
 * @returns boolean 对象不为空
 */
export function isPlainObj(obj = {}) {
    return Object.keys(obj).length > 0;
}

// 上报的参数与客户端公参的映射
const haboAppParamMap = {
    habo_did: 'habo_did',
    p_cuid: 'p_cuid',
    app_version: 'version',
    app_terminal: 'p_app_terminal',
    device_os: 'osname',
    app_channel: 'p_channel',
    name: 'biz_name',
    device_platform: 'dm',
    did: 'did',
    app_type: 'app_type'
};


export const commonParamsFromApp = {};


if (isInGaoTuApp) {
    try {
        if (location.search) {
            const queryObj = parseQuery(location.search.slice(1));

            if (isPlainObj(queryObj)) {
                // entries 暂无兼容性问题
                // https: //developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7
                Object.entries(haboAppParamMap).forEach(kv => {
                    const [reportKey, commonAppKey] = kv;
                    queryObj[commonAppKey] && (commonParamsFromApp[reportKey] = queryObj[commonAppKey]);
                });
                // 如果是在客户端，用于覆盖掉h5哈勃的gid, 后期都会统一成p_cuid
                const newGID = queryObj.habo_did || queryObj.p_cuid;
                if (newGID) {
                    commonParamsFromApp.gid = newGID;
                    commonParamsFromApp.did = newGID;
                    commonParamsFromApp.device_id = newGID;
                    cookie.set('GID', newGID, {
                        path: '/',
                        // 一年时间
                        end: 31536000
                    });
                }
            }
        }
    }
    catch (e) {
        console.error('parse commonParamsFromApp', e);
    }


}
